<template>
  <ul class="c-list--checkup">
    <li class="c-list--checkup__item">
      <span class="c-list--checkup__label judgement">判定</span>
      <div class="c-list--checkup__content">
        <p v-if="!hasError">
          あなたのWebページはHTTPS化されています。
        </p>
        <p v-else>
          指定されたページURL、もしくはページ内リンクがHTTPS通信化されていません。
        </p>
      </div>
    </li>
    <li v-if="hasError" class="c-list--checkup__item">
      <span class="c-list--checkup__label detail">内容</span>
      <div class="c-list--checkup__content">
        <p>該当するページURL、もしくはページ内リンク</p>
        <ul class="c-list--disc">
          <li v-for="(item, index) in checkNotSecureUrl" :key="index">
            {{ item }}
          </li>
        </ul>
      </div>
    </li>
    <li v-if="hasError" class="c-list--checkup__item">
      <span class="c-list--checkup__label hint">ヒント</span>
      <div class="c-list--checkup__content">
        <p>
          あなたのウェブサイトのサーバーにSSL証明書をインストールしてください。<br />
          SSL証明書をインストール済みの場合は「内容」で表示しているURLをhttpsから始まるURLに変更してください。<br />
          調査対象のドメイン以外の外部リンクがある場合は、リンクを外すもしくはhttpsから始まるURLへの変更をお願いします。
        </p>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      required: true
    },
    hasError: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    checkNotSecureUrl() {
      if (this.detail.links) {
        return this.detail.links;
      }
      return [];
    }
  }
};
</script>
